{
  "pageTitle": "Apply Now",
  "heroTitle1": "Pre-Qualification",
  "heroTitle2": "Application",
  "heroSubtitle": "Take the first step toward joining Manara School. Complete the pre-qualification form below and our admissions team will reach out shortly.",
  "parentSection": "Parent Information",
  "childSection": "Child Information",
  "parentName": "Parent full name",
  "parentNamePlaceholder": "Enter your full name",
  "email": "Email address",
  "emailPlaceholder": "you@example.com",
  "phone": "Phone number",
  "phonePlaceholder": "+20 100 000 0000",
  "phoneHint": "WhatsApp preferred",
  "location": "Governorate / country",
  "referral": "How did you hear about us?",
  "childName": "Child's full name",
  "childNamePlaceholder": "Enter child's full name",
  "childEmail": "Child's email address",
  "childEmailPlaceholder": "child@example.com (optional)",
  "childEmailHint": "Optional",
  "dob": "Date of birth",
  "grade": "Current grade",
  "applyingForGrade": "Applying for grade",
  "currentSchool": "Current school name",
  "currentSchoolPlaceholder": "e.g. New Cairo British School",
  "schoolLocation": "School location (country)",
  "schoolType": "School type",
  "nationality": "Nationality",
  "nationalityOther": "Please specify nationality",
  "nationalityOtherPlaceholder": "Type nationality",
  "selectPlaceholder": "Select...",
  "financialAidTitle": "Financial aid is available",
  "financialAidText": "Manara is committed to supporting qualified families so that ability, not cost, determines a place.",
  "submit": "Submit Inquiry",
  "submitting": "Submitting...",
  "successTitle": "We've received your inquiry",
  "successMessage": "Our admissions team will reach out shortly to help you complete your application. A confirmation has been sent to your email.",
  "referenceNumber": "Reference",
  "requiredField": "This field is required",
  "invalidEmail": "Please enter a valid email address",
  "invalidPhone": "Please enter a valid phone number",
  "invalidDate": "Please enter a valid date of birth",
  "recaptchaError": "Please verify you are not a robot",
  "genericError": "Something went wrong. Please try again.",
  "governorates": {
    "cairo": "Cairo",
    "giza": "Giza",
    "alexandria": "Alexandria",
    "qalyubia": "Qalyubia",
    "dakahlia": "Dakahlia",
    "sharqia": "Sharqia",
    "gharbia": "Gharbia",
    "monufia": "Monufia",
    "beheira": "Beheira",
    "kafrElSheikh": "Kafr El Sheikh",
    "damietta": "Damietta",
    "portSaid": "Port Said",
    "ismailia": "Ismailia",
    "suez": "Suez",
    "northSinai": "North Sinai",
    "southSinai": "South Sinai",
    "faiyum": "Faiyum",
    "beniSuef": "Beni Suef",
    "minya": "Minya",
    "asyut": "Asyut",
    "sohag": "Sohag",
    "qena": "Qena",
    "luxor": "Luxor",
    "aswan": "Aswan",
    "redSea": "Red Sea",
    "newValley": "New Valley",
    "matrouh": "Matrouh",
    "outsideEgypt": "Outside Egypt"
  },
  "grades": {
    "kg1": "KG1",
    "kg2": "KG2",
    "grade1": "Grade 1",
    "grade2": "Grade 2",
    "grade3": "Grade 3",
    "grade4": "Grade 4",
    "grade5": "Grade 5",
    "grade6": "Grade 6",
    "grade7": "Grade 7",
    "grade8": "Grade 8",
    "grade9": "Grade 9",
    "grade10": "Grade 10",
    "grade11": "Grade 11",
    "grade12": "Grade 12"
  },
  "schoolTypes": {
    "public": "Public",
    "private": "Private",
    "international": "International"
  },
  "nationalities": {
    "egyptian": "Egyptian",
    "other": "Other"
  },
  "referrals": {
    "socialMedia": "Instagram or Facebook",
    "googleSearch": "Google search",
    "friendFamily": "Friend or family",
    "schoolEvent": "School event or open day",
    "other": "Other"
  }
}
